import { createFileRoute } from '@tanstack/react-router';
import { UserAudit } from '@/features/auth/UserAudit';

export const Route = createFileRoute('/_app/user-audit')({ component: UserAudit });
